export default __webpack_public_path__ + "static/media/jackets.5c04a875.png";